import { HeroSection } from "~/contentful/components/hero-section";
import type { SerializeFrom } from "~/lib/types";
import { cn } from "~/lib/ui";

import type { loader } from "./shop.$categoryId";

export const handle: AppHandle = {
  meganav: (loaderData: SerializeFrom<typeof loader>) => {
    const data = loaderData;
    const themeData = data.heroSlotData.items[0];
    return {
      variant: themeData ? themeData.fields.navigationTextColor : "dark",
    };
  },
  contentRootHeroSlot({ heroSlotData, preview }: SerializeFrom<typeof loader>) {
    const data = heroSlotData.items[0];
    if (!data) return <></>;
    const contentType = data.fields.heroContent?.sys.contentType.sys.id;
    return (
      <div
        className={cn(
          "relative flex overflow-hidden",
          contentType !== "textBlock" && "mt-nav-adjust",
        )}
      >
        <HeroSection originalContent={heroSlotData} preview={preview} />
      </div>
    );
  },
};
export { default, headers, loader } from "./shop.$categoryId";
